<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">{{ $t('messages.password_recovery') }}</h4>
                  <p>{{ $t('messages.forgot_password') }}</p>
                </div>

                <div class="mb-8">
                  <vs-input
                    v-validate="'required|phone:mobile'"
                    data-vv-validate-on="blur"
                    name="phone"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    :label-placeholder="$t('users.phone')"
                    :data-vv-as="$t('users.phone')"
                    v-model="phone"
                    @keyup="phone = translateNumbers(phone)"
                    class="w-full"
                  />
                  <span class="text-danger text-sm">{{ errors.first('phone') }}</span>
                </div>

                <vs-button type="border" to="/pages/login" class="px-4 w-full md:w-auto">
                  {{ $t('button.back_to_log_in') }}
                </vs-button>
                <vs-button
                  :disabled="!validateForm"
                  @click="sendConfirmationCode"
                  class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0"
                  >{{ $t('button.password_recovery') }}</vs-button
                >
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { TranslateNumbers } from '@/utils'

export default {
  data() {
    return {
      phone: '',
      wait: true
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.phone !== '' && this.wait
    }
  },
  methods: {
    sendConfirmationCode() {
      const payload = {
        username: this.phone
      }

      this.wait = false

      this.$store
        .dispatch('auth/forgetPassword', payload)
        // eslint-disable-next-line no-unused-vars
        .then(response => {
          this.$notifySuccess(this.$t('messages.verification_sent'))
          this.$router.push({ name: 'page-reset-password', params: { phone: this.phone } })
        })
        .catch(() => {
          this.wait = true
        })
    },
    translateNumbers(val) {
      return TranslateNumbers(val)
    }
  }
}
</script>
